export enum MetricFunction {
  SUM = 'sum',
  AVG = 'avg',
  MIN = 'min',
  MAX = 'max',
  LOG_COUNT = 'logCount'
}

/*

  Use for metric options requesting aggregation
*/
export enum MetricsAggregation {
  RELEVANCE = 'relevance',
  COUNT = 'count',
  SMART_RELEVANCE = 'smartRelevance',
  COUNT_LOG_AND_RELEVANCE = 'countLogAndRelevance',
  COUNT_LOG_AND_TOPIC_SCORE = 'countLogAndTopicScore',
  DUMB_BIAS_CORRECTION = 'dumbBiasCorrection',
  NORMALIZED_BIAS_CORRECTION = 'normalizedBiasCorrection'
}

/*
  Options to switch values

  important: does not map exactly MetricsAggregation,
  defines what radio button to render in the UI
*/
export enum MetricsSwitch {
  RELEVANCE_SUM = 'relevance-sum',
  RELEVANCE_AVG = 'relevance-avg',
  COUNT = 'count',
  SMART_RELEVANCE = 'smart-relevance',
  COUNT_LOG_AND_RELEVANCE = 'count-log-and-relevance',
  COUNT_LOG_AND_TOPIC_SCORE = 'count-log-and-topic-score',
  DUMB_BIAS_CORRECTION = 'dumb-bias-correction',
  NORMALIZED_BIAS_CORRECTION = 'normalized-bias-correction',
  SMART_RELEVANCE_WITH_COUNT = 'smart-relevance-with-count',
  DUMB_BIAS_CORRECTION_WITH_COUNT = 'dumb-bias-correction-with-count',
  NORMALIZED_BIAS_CORRECTION_WITH_COUNT = 'normalized-bias-correction-with-count'
}

export interface MetricOptions {
  metric: MetricsAggregation;
  metricFunction?: MetricFunction;
}

// Metric options that should be fetched asynchronously
// because they can take a long time to be computed
export const ASYNC_METRIC_OPTIONS = [
  MetricsAggregation.SMART_RELEVANCE,
  MetricsAggregation.COUNT_LOG_AND_RELEVANCE,
  MetricsAggregation.COUNT_LOG_AND_TOPIC_SCORE,
  MetricsAggregation.DUMB_BIAS_CORRECTION,
  MetricsAggregation.NORMALIZED_BIAS_CORRECTION
];
// Same, but for MetricsSwitch
export const ASYNC_METRIC_SWITCH_OPTIONS = [
  MetricsSwitch.SMART_RELEVANCE,
  MetricsSwitch.COUNT_LOG_AND_RELEVANCE,
  MetricsSwitch.COUNT_LOG_AND_TOPIC_SCORE,
  MetricsSwitch.DUMB_BIAS_CORRECTION,
  MetricsSwitch.NORMALIZED_BIAS_CORRECTION,
  MetricsSwitch.SMART_RELEVANCE_WITH_COUNT,
  MetricsSwitch.DUMB_BIAS_CORRECTION_WITH_COUNT,
  MetricsSwitch.NORMALIZED_BIAS_CORRECTION_WITH_COUNT
];
